export {ClientCredentialsForm} from './client-credentials-form';
export {clientCredentialsFormI18n } from './client-credentials-form.i18n'

